import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';

import { FLAG_EMOJI_FONT } from '../constants/flagEmojiFont';

/**
 * Windows has no flag emojis and shows the letters instead (`MX` for 🇲🇽). Where the browser can't draw them, this
 * adds a flags-only font from `fontUrl` (the app serves the file); elsewhere it loads nothing. Call once at start.
 */
export function polyfillFlagEmojis(fontUrl: string): void {
    try {
        polyfillCountryFlagEmojis(FLAG_EMOJI_FONT, fontUrl);
    } catch {
        // The check draws on a canvas; where that's blocked (privacy extensions) the flags simply stay letters.
    }
}
